<template>
  <van-swipe
    :class="_.carousel"
    :autoplay="autoplay ? 3000 : undefined"
    @change="handleChange"
  >
    <van-swipe-item
      v-for="(item, index) in list"
      :key="item.image"
      @click="handleClick(item, index)"
    >
      <slot name="item" :item="item" :index="index" :current="current">
        <img :src="item.image" />
      </slot>
    </van-swipe-item>
    <template v-if="isCounterIndicator" #indicator>
      <div :class="_.counter">{{ current + 1 }}/{{ total }}</div>
    </template>
  </van-swipe>
</template>

<script>
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'
  import { ImagePreview } from 'vant'

  export default Vue.extend({
    props: {
      data: {
        type: Array,
        required: true,
      },
      autoplay: {
        type: Boolean,
        default: true,
      },
      // dot, counter
      indicatorType: {
        type: String,
        default: 'dot',
      },
    },

    data: () => ({
      current: 0,
    }),

    computed: {
      isCounterIndicator() {
        return this.indicatorType === 'counter'
      },
      list() {
        return this.data.map(item =>
          typeof item === 'string'
            ? {
                image: item,
              }
            : {
                ...item,
                image: item.image || item.icon,
                url: item.url || item.targetUrl,
                isResource: !!item.stateId,
              },
        )
      },
      total() {
        return this.list.length
      },
    },

    methods: {
      handleChange(index) {
        this.current = index
      },
      handleClick(item, index) {
        this.$emit('click', item, index)
        if (item.isResource) {
          this.$handleResourceClick(item)
        } else if (item.url) {
          dcb.navigateTo({
            url: item.url,
          })
        } else if (!item.disablePreview) {
          ImagePreview({
            images: this.list.map(item => item.image),
            startPosition: index,
          })
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .carousel {
    img,
    :global(.__image_like__) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .counter {
      position: absolute;
      right: 12px;
      bottom: 12px;
      width: 38px;
      height: 20px;
      background: rgba(#383838, 0.7);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #ffffff;
      line-height: 17px;
    }

    :global {
      .van-swipe {
        &__indicators {
          bottom: 4px;
        }

        &__indicator {
          width: 8px;
          height: 2px;
          border-radius: 100px;
          background-color: rgba(white, 0.7);

          &--active {
            background-color: #ff111c !important;
          }

          &:not(:last-child) {
            margin-right: 3px;
          }
        }
      }
    }
  }
</style>
